import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
//import AdbIcon from '@mui/icons-material/Adb';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Link, Outlet, useNavigate} from 'react-router-dom';
import {deleteCookie, getCookie} from '../../functions/Cookie';
import Filtration from './filtration';
import {useAppDispatch} from '../../hooks/hooks';
import {auth, MainState} from '../../reducers/mainSlice';
import Divider from '@mui/material/Divider';
import СhatUnreadMessages from '../forAll/chatUnreadMessages'

const getPageList = () => {
  const realId = getCookie('uid');
  let pages = [
    {name: 'Главная', link: ''},
    {name: 'Рекомендации', link: 'info'},
    {name: 'Избранное', link: 'favorites'},
    {name: 'Подписчики VK', link: 'vk'}
  ];
  if (window.location.pathname !== '/base') {
    if (realId == '9735' || realId == '513') {
      pages.push({name: 'Чат', link: 'chat'})
    }
    // if (localStorage.getItem('vkpage') == '1') {
    //     pages.push({name: 'Подписчики VK', link: 'vk'})
    // }
  }
  return pages;
}

const pages = getPageList();

/*var pages = [
    {name: 'Главная', link: ''},
    {name: 'Рекомендации', link: 'info'},
    {name: 'Избранное', link: 'favorites'},
];*/
//window.location.pathname !== '/base' && pages.push({ name: 'Избранное', link: 'favorites' })

const CabinetHeader = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useAppDispatch();
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');


  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const {current: descriptionElement} = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  let navigate = useNavigate();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (link: boolean | string) => {
    setAnchorElNav(null);
    if (link !== false) {
      let newLink = link.toString();
      navigate(newLink);
    }
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const menuStatus = (String(getCookie('menu')) == '766186' ? true : false);

  const Logout = () => {
    deleteCookie('role');
    deleteCookie('token');
    deleteCookie('tariff');
    deleteCookie('coins');
    deleteCookie('gender');
    deleteCookie('update_time');
    deleteCookie('use_coins');
    deleteCookie('menu');
    deleteCookie('uid');
    localStorage.clear();
    dispatch(auth({} as MainState))
    navigate('/', {replace: true});
  }

  const showConfig = () => {
    if (menuStatus) {
      return (
        <MenuItem onClick={() => handleCloseNavMenu(false)}>
          <Typography textAlign="center">
            <Button variant="text" onClick={handleOpen}>
              Настройки
            </Button>
          </Typography>
        </MenuItem>
      );
    } else {
      return null;
    }
  }
  const showConfig2 = () => {
    if (menuStatus) {
      return (
        <DialogTitle id="scroll-dialog-title">Настройки</DialogTitle>
      );
    }
    return null;
  }

  const showConfig3 = () => {
    if (menuStatus) {
      return (
        <Button
          onClick={handleOpen}
          sx={{my: 2, color: 'white', display: 'block'}}
        >
          Настройки
        </Button>
      );
    }
    return null;
  }

  const getUserName = () => {
    let name = localStorage.getItem('firstname')
    if (name) {
      return name;
    } else {
      return ''
    }
  }
  const getAvatarUrl = () => {
    let avatar = localStorage.getItem('avatar')
    if (avatar) {
      return '/upload/' + avatar;
    } else {
      return '/images/user.png'
    }
  }

  return (
    <>
      <AppBar position="static" sx={{
        marginBottom: '3vh',
        backgroundColor: '#05b5cd',
        background: 'linear-gradient(to right,  #05b5cd 0%,#02d2d2 100%)'
      }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Dialog
              open={open}
              onClose={handleClose}
              scroll={scroll}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
            >
              {showConfig2()}
              <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText
                  id="scroll-dialog-description"
                  ref={descriptionElementRef}
                  tabIndex={-1}
                >
                  <Filtration/>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Закрыть</Button>
              </DialogActions>
            </Dialog>
            <Box sx={{display: {xs: 'flex', md: 'none'}}}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon/>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={() => handleCloseNavMenu(false)}
                sx={{
                  display: {xs: 'block', md: 'none'},
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page.link} onClick={() => handleCloseNavMenu(page.link)}>
                    <Link style={{textDecoration: 'none', color: "dimgray", textAlign: "center"}} to={page.link}>
                      <Typography textAlign="center">
                        {page.name}
                        {page.link === 'chat' && СhatUnreadMessages(1)}
                      </Typography>
                    </Link>
                  </MenuItem>
                ))}
                {showConfig()}
              </Menu>
            </Box>
            <Link to={''}>
              <Avatar variant="square" sx={{
                '&': {
                  width: 'auto',
                  maxWidth: '45px'
                },
                marginLeft: {xs: '8px', md: '0px'},
                marginRight: '10px',
                maxWidth: '45px'
              }} src='/images/logo.png'/>
            </Link>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: {xs: 'none', md: 'flex'},
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <Link to={''} style={{textDecoration: 'none', color: "white", textAlign: "center"}}>AstroDating</Link>
            </Typography>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/cabinet"
              sx={{
                mr: 2,
                display: {xs: 'flex', md: 'none'},
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.2rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              AstroDating
            </Typography>
            <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
              {pages.map((page) => (
                <Button
                  key={page.link}
                  onClick={() => handleCloseNavMenu(page.link)}
                  sx={{my: 2, color: 'white', display: 'block'}}
                >
                  <Link style={{textDecoration: 'none', color: "white"}} to={page.link}>
                    {page.name}
                    {page.link === 'chat' && СhatUnreadMessages(0)}
                  </Link>
                </Button>
              ))}
              {showConfig3()}
            </Box>

            <Box sx={{flexGrow: 0}}>
              <Tooltip title="Меню">
                <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                  <Avatar alt={getUserName()} src={getAvatarUrl()}/>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{mt: '45px'}}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem component={Link} to='/cabinet/profile'>
                  <Typography textAlign="center">Профиль</Typography>
                </MenuItem>
                {/*<MenuItem component={Link} to='/cabinet/favorites'>
                                    <Typography textAlign="center">Избранное</Typography>
                                </MenuItem>
                                <MenuItem component={Link} to='/cabinet/info'>
                                    <Typography textAlign="center">Рекомендации</Typography>
                                </MenuItem>*/}
                <Divider/>
                <MenuItem key='exit' onClick={Logout}>
                  <Typography textAlign="center">Выйти</Typography>
                </MenuItem>

              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Outlet/>
    </>

  );
};
export default CabinetHeader;
